export default __webpack_public_path__ + "static/media/landtrust-plus-v2.8075f0ca.webp";